import { fetch } from '@/utils/fetch';

/**
 * 查询列表
 * @returns {Promise<Response>}
 */
export function _queryGoods(
  {
    status,
    seriesId,
    categoryId,
    name,
    page,
    size,
    direction,
    sort,
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods`,
    method: 'get',
    params: {
      status,
      seriesId,
      categoryId,
      name,
      page,
      size,
      direction,
      sort,
    },
  });
}

/**
 * 根据 id 查询
 * @returns {Promise<Response>}
 */
export function _queryGoodsById(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}`,
    method: 'get',
  });
}

/**
 * 新增
 */
export function _addGoods(
  {
    name,
    nameEn,
    code,
    seriesId,
    categoryId,
    content,
    coverPath,
    images,
    limitedQuantity,
    status,
    isPresell,
    sellStartAt,
    sellEndAt,
    price,
    listPrice,
    description,
    descriptionEn,
    salesQuantity,
    type,
    inspirationImg,
    inspirationVideo,
    previousPrice,
    isLimited,
    isVip,
    sizeImage,
    vipCategoryId,
    vipSeriesId,
    isNew,
    startPrice,
    endPrice,
    isSpecialSettlement
  },
) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods`,
    method: 'post',
    data: {
      name,
      nameEn,
      code,
      seriesId,
      categoryId,
      content,
      coverPath,
      images,
      limitedQuantity,
      status,
      isPresell,
      sellStartAt,
      sellEndAt,
      price,
      listPrice,
      description,
      descriptionEn,
      salesQuantity,
      type,
      inspirationImg,
      inspirationVideo,
      previousPrice,
      isLimited,
      isVip,
      sizeImage,
      vipCategoryId,
      vipSeriesId,
      isNew,
      startPrice,
      endPrice,
      isSpecialSettlement,
    },
  });
}

/**
 * 更新
 */
export function _updateGoods(goodsId, {
  name,
  nameEn,
  type,
  code,
  seriesId,
  categoryId,
  content,
  coverPath,
  images,
  limitedQuantity,
  status,
  isPresell,
  sellStartAt,
  sellEndAt,
  price,
  listPrice,
  description,
  descriptionEn,
  salesQuantity,
  inspirationImg,
  inspirationVideo,
  previousPrice,
  isLimited,
  isVip,
  sizeImage,
  vipCategoryId,
  vipSeriesId,
  isNew,
  startPrice,
  endPrice,
  isSpecialSettlement
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}`,
    method: 'patch',
    data: {
      name,
      nameEn,
      type,
      code,
      seriesId,
      categoryId,
      content,
      coverPath,
      images,
      limitedQuantity,
      status,
      isPresell,
      sellStartAt,
      sellEndAt,
      price,
      listPrice,
      description,
      descriptionEn,
      salesQuantity,
      inspirationImg,
      inspirationVideo,
      previousPrice,
      isLimited,
      isVip,
      sizeImage,
      vipCategoryId,
      vipSeriesId,
      isNew,
      startPrice,
      endPrice,
      isSpecialSettlement
    },
  });
}

/**
 * 删除
 * @param goodsId
 * @param code
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _setGoodsBasicSpec(goodsId, { code }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/basic-spec`,
    method: 'patch',
    data: {
      basicSpec: code,
    },
  });
}

/**
 * 上移
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _upGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/up`,
    method: 'patch',
  });
}

/**
 * 下移
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _downGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/down`,
    method: 'patch',
  });
}

/**
 * 删除
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _deleteGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}`,
    method: 'delete',
  });
}

/**
 * 根据分类id 查询商品；
 * @param  categoryId
 * @returns
 */
export function _queryGoodsByCategoryId(categoryId, {
  page,
  size,
  sort,
  direction
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/category/${categoryId}`,
    method: 'get',
    params: {
      page,
      size,
      sort,
      direction
    }
  });
}

/**
 * 批量更新
 * @param status
 * @param goodsIds
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _multiUpdateGoods(goodsIds, status) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/multi/${status}`,
    method: 'patch',
    data: goodsIds,
  });
}

/**
 * 根据hbxIds上架
 */
export function _uploadGoodsByHbxIds({
  hbxGoodsIds
}) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/multi-upload`,
    method: 'post',
    params: {
      hbxGoodsIds
    }
  });
}

/**
 * 下架
 * @param goodsId
 * @returns {Promise<*|undefined>}
 * @private
 */
export function _offGoods(goodsId) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/${goodsId}/off`,
    method: 'patch',
  });
}

export function _importGoods(
  {
    goods,
    goodsAttributeValue,
    goodsSKU,
    goodsSkuAttributeValue,
  }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/goods/import`,
    method: 'post',
    data: {
      goods,
      goodsAttributeValue,
      goodsSKU,
      goodsSkuAttributeValue,
    }
  });
}
